<template>
  <v-textarea
    v-model="someModelClone"
    rows="1"
    :rules="config.parsing_rules"
    :label="config.label"
    :placeholder="config.placeholder"
    auto-grow
    :counter="config.max_chars_count"
    v-on:change="changed()"
  >
    <template v-slot:append>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on">help_outline</v-icon>
        </template>
        <span v-html="config.help"></span>
      </v-tooltip>
    </template>
  </v-textarea>
</template>

<script>
export default {
  name: "soda-text-area",
  props: {
    config: Object,
    someModel: String,
  },
  watch: {
    someModelClone() {
      this.$emit("input", this.someModelClone);
    },
    someModel() {
      this.someModelClone = this.someModel;
    },
  },
  methods: {
    changed() {
      this.$emit("change");
    },
  },
  // NOTE: if arrow function is used here, someModel won't be accessible
  data() {
    return {
      someModelClone: this.someModel,
    };
  },
};
</script>

<style scoped></style>
